query processStats($filter: ProcessStatFilterInput) {
  base {
    processStats(filter: $filter) {
      items {
        id
        scenarioId
        processId
        scenario {
          id
          name
          status {
            id
            value
          }
          workspace {
            id
            name
            __typename
          }
          __typename
        }
        label
        attributes {
          isProductive
          isReal
          isVisible
          isProtected
        }
        processType
        moduleType
        stats
        __typename
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
      }
      __typename
    }
    __typename
  }
}
